import React, { useEffect, useMemo } from 'react';

import { Formik } from 'formik';

import Button from 'CommonComponents/Button';
import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';
import ToggleFormField from 'CommonComponents/ToggleFormField';

import useApiRequest from 'Hooks/useApiRequest';

export default function NotificationSettingsModal(props) {
    const close = () => {
        props.modal.hide();
    };

    return (
        <Modal id={props.id} modal={props.modal}>
            <ModalHeader title={$t('Notification Settings')} close={close}></ModalHeader>
            <div className="tw-rounded-b">
                {props.isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div className="modal__form-container">
                        <NotificationSettingsForm
                            fetchNotificationSettingsUrl={props.fetchNotificationSettingsUrl}
                            upsertNotificationSettingsUrl={props.upsertNotificationSettingsUrl}
                            onSuccess={() => close()}
                            onCancel={() => close()}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
}

function NotificationSettingsForm(props) {
    const fetchNotificationSettingsRequest = useApiRequest({ url: props.fetchNotificationSettingsUrl });
    const upsertNotificationSettingsRequest = useApiRequest({
        url: props.upsertNotificationSettingsUrl,
        successMessage: $t('Notification settings saved successfully'),
        errorMessage: $t('An error ocurred while saving notification settings'),
    });

    const { data: notificationSettings } = fetchNotificationSettingsRequest;

    const initialValues = useMemo(() => {
        if (!notificationSettings?.modules_names || !notificationSettings?.settings) {
            return notificationSettings?.default_settings;
        }

        return Object.keys(notificationSettings?.modules_names).reduce(
            (data, code) => {
                data.enabled_modules[code] =
                    notificationSettings?.settings.data.enabled_modules && typeof notificationSettings?.settings.data.enabled_modules[code] === 'boolean'
                        ? notificationSettings?.settings.data.enabled_modules[code]
                        : false;
                return data;
            },
            { enabled_modules: {} },
        );
    }, [notificationSettings]);

    useEffect(() => {
        fetchNotificationSettingsRequest.get();
    }, []);

    return (
        <div>
            {!!notificationSettings?.modules_names && !!initialValues && (
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    onSubmit={(values, actions) => {
                        upsertNotificationSettingsRequest
                            .put(values)
                            .catch((e) => {
                                actions.setErrors(e.response.data.errors);
                            })
                            .finally(() => {
                                actions.setSubmitting(false);
                            });
                    }}
                >
                    {({ values, errors, touched, isSubmitting, handleSubmit }) => (
                        <div>
                            {Object.entries(notificationSettings?.modules_names).map(([code, name]) => (
                                <div key={code} className="form-group">
                                    <ToggleFormField
                                        label={name}
                                        type="checkbox"
                                        name={`enabled_modules.${code}`}
                                        id={`enabled_modules.${code}`}
                                    ></ToggleFormField>
                                    {errors &&
                                        errors.enabled_modules &&
                                        errors.enabled_modules[code] &&
                                        touched &&
                                        touched.enabled_modules &&
                                        touched.enabled_modules[code] && <div className="text-danger">{errors.enabled_modules[code]}</div>}
                                </div>
                            ))}

                            <div className="tw-flex tw-justify-end tw-gap-x-1">
                                <Button variant="danger" onClick={() => props.onCancel()}>
                                    {$t('Cancel')}
                                </Button>
                                <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
                                    {$t('Save')}
                                </Button>
                            </div>
                        </div>
                    )}
                </Formik>
            )}
        </div>
    );
}
